var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5L16 8.5M16 8.5L15.5 8.75L11 11M16 8.5V12M16 8.5L6.5 3.5M11 11L2 6.5M11 11V20.5M14.578 2.382L16.578 3.432C18.729 4.561 19.805 5.125 20.403 6.14C21 7.154 21 8.417 21 10.942V11.059C21 13.583 21 14.846 20.403 15.86C19.805 16.875 18.729 17.44 16.578 18.569L14.578 19.618C12.822 20.539 11.944 21 11 21C10.056 21 9.178 20.54 7.422 19.618L5.422 18.568C3.271 17.439 2.195 16.875 1.597 15.86C1 14.846 1 13.583 1 11.06V10.943C1 8.418 1 7.155 1.597 6.141C2.195 5.126 3.271 4.561 5.422 3.433L7.422 2.383C9.178 1.461 10.056 1 11 1C11.944 1 12.822 1.46 14.578 2.382Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineOrderIcon);
export default __webpack_public_path__ + "static/media/onlineOrderIcon.380a5732c33f8aededb5e8050e825e7a.svg";
export { ForwardRef as ReactComponent };